import {
  Circle,
  CircleNotch,
  CheckCircle,
  MinusCircle,
} from '@phosphor-icons/react';
import { cn } from '@/lib/utils';
import type { TodoItem } from './types';

const STATUS_ICONS = {
  pending: <Circle className="h-4 w-4 text-stone-300" />,
  'in-progress': (
    <CircleNotch className="h-4 w-4 text-purple-500 animate-spin" />
  ),
  done: <CheckCircle className="h-4 w-4 text-emerald-500" weight="fill" />,
  skipped: <MinusCircle className="h-4 w-4 text-stone-400" />,
} as const;

interface TodoListItemProps {
  item: TodoItem;
  subtitle?: string;
}

export function TodoListItem({ item, subtitle }: TodoListItemProps) {
  return (
    <div className="flex items-start gap-2 py-0.5">
      <span className="shrink-0 mt-0.5">{STATUS_ICONS[item.status]}</span>
      <div>
        <span
          className={cn(
            'text-xs leading-tight',
            item.status === 'done' && 'text-stone-500',
            item.status === 'skipped' && 'text-stone-400 line-through',
            item.status !== 'done' &&
              item.status !== 'skipped' &&
              'text-stone-700',
          )}
        >
          {item.label}
        </span>
        {item.status === 'in-progress' && subtitle && (
          <span className="block text-[10px] text-stone-400 animate-pulse">
            {subtitle}
          </span>
        )}
      </div>
    </div>
  );
}
